'use client';

import { createContext, ReactNode, useCallback, useState } from "react";

// The ReinitContext serves to register handlers to perform
// when the user clicks on the Submit new job menu item or the logo.
// This is effectively used only on the input page because the state is
// refreshed automatically when transitioning from other pages to the input page
// (contexts with input state live in the input layout).

export type ReinitHandlerType = () => void;

type ReinitContextType = ReturnType<typeof useProviderValue>;

export const ReinitContext = createContext<ReinitContextType>(null as any);

export function ReinitContextProvider({children}: {children: ReactNode}) {
  const value = useProviderValue();
  return (
    <ReinitContext.Provider value={value}>{children}</ReinitContext.Provider>
  )
}

function useProviderValue() {
  const [reinitHandlers, setReinitHandlers] = useState<ReinitHandlerType[]>([]);
  const addReinitHandler = useCallback((handler: ReinitHandlerType) => {
    setReinitHandlers(handlers => {
      return [
        ...handlers,
        handler,
      ]
    })
  }, []);
  const removeReinitHandler = useCallback((handler: ReinitHandlerType) => {
    setReinitHandlers(handlers => {
      return handlers.filter(h => h !== handler);
    })
  }, []);
  return {
    reinitHandlers,
    addReinitHandler,
    removeReinitHandler,
  }
}